// extracted by mini-css-extract-plugin
export var cardContainer = "_oa-0";
export var cardHeader = "_oa-2";
export var collapsedState = "_oa-3";
export var dragHandle = "_oa-5";
export var dragHandleIcon = "_oa-6";
export var dragging = "_oa-1";
export var titleArea = "_oa-4";